import type { AppliedLesson } from '@/models/appliedlesson';
import type { XAppliedLesson } from '@/models/xappliedlesson';
import type { PMAppliedLesson } from '@/models/pmappliedlesson';

export const enum CheckedEnum {
    'Checked' = 'checked',
    'NotChecked' = 'not_checked',
    'NeedsCheck' = 'needs_check',
    'All' = 'all',
}

export const filterAppliedLessonsChecked = <T extends AppliedLesson | XAppliedLesson | PMAppliedLesson>(
    appliedLesson: T,
    checked: CheckedEnum
) => {
    switch (checked) {
        case CheckedEnum.All:
            return true;
        case CheckedEnum.NeedsCheck:
            return appliedLesson.needscheck;
        case CheckedEnum.Checked:
            return appliedLesson.needscheck && appliedLesson.checked;
        case CheckedEnum.NotChecked:
            return appliedLesson.needscheck && !appliedLesson.checked;
    }
};
